import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { CountrySelectManager } from 'src/app/data/manager/country-select/country-select.manager';
import { CountrySelect } from 'src/app/data/networking/models/country-select/country-select';

@Injectable({
  providedIn: 'root',
})
export class CountrySelectVm {
  public customer: any;
  public creditCardId: any;
  public defaultCard: any;

  constructor(
    private countrySelectManager: CountrySelectManager,
  ) { }

  getCountries(): Observable<CountrySelect[]> {
    return this.countrySelectManager.getCountries()
  }
}
